import React, { Component } from 'react';
import axios from 'axios';

class Webblog extends Component {
  state = {
    articles: [],
    error: null
  };

  componentDidMount() {
    const apiKey = 'pub_9687aa81924245e5afdbfa4249dc7357'; // Replace with your actual key
    const url = `https://newsdata.io/api/1/news?apikey=${apiKey}&country=in&category=health&language=en`;

    axios.get(url)
      .then(response => {
        this.setState({ articles: response.data.results });
      })
      .catch(error => {
        this.setState({ error: 'Failed to fetch health news' });
      });
  }

  render() {
    const { articles, error } = this.state;

    return (
      <div>
        {/* <hr className='m-0' style={{ background: '#D3F2FF' }} /> */}
        <div className='hospital-details py-5'>
          <div className='container col-lg-11'>
            <div className='d-flex justify-content-between align-items-center mb-5'>
              <div>
                <h1 style={{ color: '#00275a', textAlign: 'left', fontSize: '27px' }}>Health Insight and Updates</h1>
                <h4 style={{ color: '#0C101B', textAlign: 'left' }}>Our Blog</h4>
              </div>
              {/* Arrows remain unchanged */}
            </div>

            <div className='row m-0 align-items-stretch justify-content-center'>
              {error && <p style={{ color: 'red' }}>{error}</p>}
              {articles.slice(0, 3).map((article, index) => (
                <div key={index} className='col-lg-4 col-md-6 col-sm-6 col-12 my-lg-0 my-md-2 my-sm-2 slide-right visible'>
                  <div className='patientblog'>
                    <div className='img-sectionblog'>
                      <img
                        src={article.image_url || require("../../src/assets/images/website/doctor1.webp")}
                        className='w-100'
                        style={{ objectFit: 'cover', height: '250px' }}
                        alt='Health News'
                      />
                    </div>
                    <div className='doctor-contentblog'>
                      <div className='white-box1'>
                        <h1 style={{ color: 'black' }}>{article.title}</h1>
                        <div className='inner-contentss'>
                          <div className='pb-1'>
                            <p style={{ color: 'gray' }}>{article.description || 'Click below to read more.'}</p>
                            <a href={article.link} target='_blank' rel='noopener noreferrer'>Read more</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default Webblog;
